__turbopack_context__.v({
  "className": "noto_sans_sc_2de8752d-module__un2WhG__className",
});
